var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({ variant: 'base', placement: 'top',
  placement:'top',
  boundary:'viewport' }),expression:"{ variant: 'base', placement: 'top',\n  placement:'top',\n  boundary:'viewport' }",modifiers:{"hover":true}}],staticClass:"button d-inline-block rounded-circle project-initials-btn",style:({
    backgroundColor: _vm.projectColor || '#6c757d',
    borderColor: _vm.projectColor || '#6c757d',
  }),attrs:{"variant":"secondary","size":"sm","title":_vm.tooltipTitle},on:{"click":function($event){return _vm.$emit('click', _vm.projectData)}}},[_vm._v("\n  "+_vm._s(_vm.getInitials(_vm.projectName))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }